import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Close from '@material-ui/icons/Clear';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import './lineLoader.css';

import IframeDialogComponentStyles from './IframeDialogComponentStylesV2';
import { getStringFromObject } from '../../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';

class IframeDialogComponentV2 extends React.Component {
    constructor(props) {
        super(props);
        this.iframeRef = React.createRef();
        this.state = {
            dialogActions: props.dialogActions,
            iframeLoading: true,
            header: props.header,
        };
    }

    componentDidMount() {
        window.addEventListener('message', this.handleIframeMessage); // done
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleIframeMessage); // Done
    }

    handleIframeLoad = () => {
        this.setState({ iframeLoading: false }); // Done
    };

    // Done
    handleIframeMessage = (event) => {
        if (event.data === 'closeIframe') {
            this.props.handleClose();
        } else if (isObjectValidAndNotEmpty(event.data)) {
            const task = getStringFromObject('task', event.data);
            if (task === 'readyToReceiveMessage') {
                this.postMessageToChild();
            }

            if (task === 'updateHeader') {
                const header = getStringFromObject('header', event.data);
                this.setState({
                    header,
                });
            }
        }
    };

    // Done
    postMessageToChild = () => {
        const { dataToPostOnLoad } = this.props;
        if (
            isObjectValidAndNotEmpty(dataToPostOnLoad)
            && this.iframeRef.current
            && this.iframeRef.current.contentWindow
        ) {
            const iframeWindow = this.iframeRef.current.contentWindow;
            if (iframeWindow) {
                iframeWindow.postMessage(dataToPostOnLoad, '*');
            }
        }
    };

    render() {
        const {
            classes,
            open,
            handleClose,
            fullScreen,
            handleClick,
            maxWidth,
            disableEnforceFocus,
            disableEscapeKeyDown,
            disableBackdropClick,
            iframeUrl,
            titleStyle,
        } = this.props;
        const {
            dialogActions,
            iframeLoading,
            header,
        } = this.state;

        let propsToSpread = {};
        if (!this.props.fullScreen) {
            propsToSpread = { ...this.props };
        }
        return (
            <Dialog
                {...this.props}
                open={open}
                maxWidth={maxWidth}
                scroll="body"
                fullScreen={fullScreen}
                aria-labelledby="form-dialog-title"
                className={classes.dialog}
                onClick={handleClick}
                onClose={handleClose}
                disableEnforceFocus={disableEnforceFocus}
                disableEscapeKeyDown={disableEscapeKeyDown}
                disableBackdropClick={disableBackdropClick}
                {...propsToSpread}
            >
                <DialogTitle id="form-dialog-title" className={classes.title} style={titleStyle || {}}>
                    <Grid container justify="space-between">
                        <div className={classes.header}>{header}</div>
                        <Close
                            test-id={`${header}-close`}
                            className={classNames(classes.closeIcon, 'cursor-pointer')}
                            onClick={handleClose}
                        />
                    </Grid>
                </DialogTitle>
                <DialogContent
                    className={classes.dialogContent}
                    style={{ overflowY: this.props.overflowY }}
                >
                    <Grid container style={{ height: '100%' }}>
                        {
                            iframeLoading
                                ? (
                                    <div className="load-bar">
                                        <div className="bar" />
                                    </div>
                                )
                                : null
                        }
                        <iframe
                            onLoad={this.handleIframeLoad}
                            title="test"
                            src={iframeUrl}
                            width="100%"
                            height="100%"
                            style={{ display: iframeLoading ? 'none' : 'block' }}
                            frameBorder="0"
                            ref={this.iframeRef}
                        />
                    </Grid>
                </DialogContent>
                {
                    dialogActions && (
                        <DialogActions style={{ padding: '12px', marginTop: '0px' }}>
                            {dialogActions}
                        </DialogActions>
                    )
                }
            </Dialog>
        );
    }
}

IframeDialogComponentV2.propTypes = {
    classes: PropTypes.object,
    header: PropTypes.string,
    overflowY: PropTypes.string,
    open: PropTypes.bool,
    disableEscapeKeyDown: PropTypes.bool,
    disableEnforceFocus: PropTypes.bool,
    disableBackdropClick: PropTypes.bool,
    fullScreen: PropTypes.bool,
    fullWidth: PropTypes.bool,
    dialogActions: PropTypes.node,
    children: PropTypes.node,
    handleClose: PropTypes.func,
    handleClick: PropTypes.func,
    maxWidth: PropTypes.oneOf(['lg', 'md']),
    iframeUrl: PropTypes.string.isRequired,
    titleStyle: PropTypes.object,
    dataToPostOnLoad: PropTypes.object,
};

IframeDialogComponentV2.defaultProps = {
    classes: {},
    header: '',
    open: false,
    fullScreen: false,
    disableEnforceFocus: false,
    disableEscapeKeyDown: false,
    disableBackdropClick: false,
    fullWidth: true,
    dialogActions: null,
    children: null,
    maxWidth: 'md',
    handleClose: () => {},
    handleClick: () => {},
    overflowY: '',
    titleStyle: {},
    dataToPostOnLoad: null,
};

export default withStyles(IframeDialogComponentStyles)(withMobileDialog()(IframeDialogComponentV2));
